/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, March 30th 2022, 3:36:53 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { BillingConfigurationForm } from "service-builder/components/billing";
import { useParams } from "react-router-dom";

export const BillingConfigurationPage = () => {
  const { billingConfigurationId } = useParams();
  return <BillingConfigurationForm billingConfigurationId={billingConfigurationId} />;
};
